import { instance } from "@/utils/api";
import { useMutation, useQuery } from "@tanstack/react-query";
import useAxios from "../axios";

export const useGetSubscriptionPlans = (params) => {
  return useQuery({
    queryKey: ["getSubscriptionPlans", params],
    queryFn: async () => {
      const { data } = await instance.get("subscription/plan", {
        params,
      });
      return data;
    },
  });
};

export const useUpgradeOrRenewPlan = () => {
  const instanceWithToken = useAxios();
  // const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.post("subscription", body);
      return data;
    },
    //   onSuccess: () => {
    //     queryClient.invalidateQueries({ queryKey: ["getNotifications"] });
    //   },
  });
};

export const useSubscriptionPayment = () => {
  const instanceWithToken = useAxios();
  // const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.post(
        "subscription/payment",
        body
      );
      return data;
    },
    //   onSuccess: () => {
    //     queryClient.invalidateQueries({ queryKey: ["getNotifications"] });
    //   },
  });
};

export const useSubscriptionRenewInfo = () => {
  const instanceWithToken = useAxios();

  return useQuery({
    queryKey: ["subscriptionRenewInfo"],
    queryFn: async () => {
      const { data } = await instanceWithToken.get("subscription/renew/info");
      return data;
    },
  });
};

export const useSubscriptionUpgradeInfo = () => {
  const instanceWithToken = useAxios();

  return useQuery({
    queryKey: ["subscriptionUpgradeInfo"],
    queryFn: async () => {
      const { data } = await instanceWithToken.get("subscription/upgrade/info");
      return data;
    },
  });
};

export const useSubscriptionDashboard = () => {
  const instanceWithToken = useAxios();

  return useQuery({
    queryKey: ["subscriptionDashboard"],
    queryFn: async () => {
      const { data } = await instanceWithToken.get("subscription/dashboard");
      return data;
    },
  });
};
